import React from 'react'
import { Modal } from 'react-bootstrap'
import { i18nTranslate } from 'src/utils'
import './styles.scss'

class EventModal extends React.Component {
  handleClose = () => {
    this.props?.disableEventModal()
  }

  render() {
    const { show = false, modalTitle = '', modalMessage = '' } = this.props

    return (
      <>
        <Modal
          className="event-timeline-modal"
          show={show}
          onHide={this.handleClose}>
          <Modal.Header className="event-modal-header" closeButton>
            <Modal.Title>
              {modalTitle
                ? modalTitle
                : i18nTranslate(
                    'event.homeLive2024',
                    'Thank you for coming to L!VE 2024!',
                    {
                      nameSpace: 'ssr-resource',
                    }
                  )}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="event-modal-body">
            <div className="event-modal-body-primary">{modalMessage || ''}</div>
            {/* {showRedirection && (
              <div className="event-modal-body-redirection">
                {i18nTranslate(
                  'event.homeOrderHistory',
                  'L!VE Event order history is available at',
                  {
                    nameSpace: 'ssr-resource',
                  }
                )}{' '}
                <a
                  className="event-modal-redirection-link"
                  href={i18nTranslate(
                    'event.homeOrderHistoryLink',
                    'https://www.nuskin.com/us/en/',
                    {
                      nameSpace: 'ssr-resource',
                    }
                  )}
                  target="_blank"
                  rel="noopener noreferrer">
                  {i18nTranslate('event.homeOrderHistoryText', 'nuskin.com', {
                    nameSpace: 'ssr-resource',
                  })}
                </a>
              </div>
            )} */}
          </Modal.Body>
        </Modal>
      </>
    )
  }
}

export { EventModal }
